<template>
	<div class="stage stage--intro__block" :style="{ 'background-image': backgroundImage }">
		
		<div class="stage__background-overlay background-overlay">
			
			<div class="content-container">

				<div class="header__container shadow-box">
					<div class="subHeader" style="position: relative" v-html="stageData.subheader">
					</div>
					<div class="header" style="position: relative" v-html="stageData.header">
					</div>
					<div class="text" style="position: relative" v-html="stageData.story">
					</div>
				</div>

				<Lottie
						:animationpath="baseUrl + stageData.visual"
						name="intro-animation"
						loop="true"
						ratio="meet"
						autoplay="true"
						style="margin:auto; position: relative"
						v-if="visualExists && visualIsJson"
				/>

				<div v-else-if="visualExists" class="centered" style="position: relative">
					<img
							:src="baseUrl + stageData.visual"
							class="visual"
					/>
				</div>


				<div v-if="stageData.slides.length > 0" class="slider">

					<div v-for="slide,index in stageData.slides" class="slide">
						<div class="title" style="position: relative" v-html="slide.title">
						</div>
						<div class="slide-text" style="position: relative" v-html="slide.text">
						</div>
						<img v-if="typeof slide.visual !== 'undefined'" :src="baseUrl + slide.visual"/>
					</div>

				</div>

			</div>
			
		</div>

	</div>
</template>

<script>

	import {mapGetters , mapActions} from 'vuex';
	import { url} from '../../const/base';
	import Lottie from '../Lottie.vue';

	export default {
		components:{
			Lottie,
		},
		props:[
		],

		beforeMount(){

			if(typeof this.stageData.slides === 'undefined'){
				this.stageData.slides = [];
			}

		},

		mounted(){
			setTimeout(()=>{
				this.setNextButtonAction(this.toNextStage).then(()=>{
					this.showNextButton({"btn":true , "btn-progres":true , "btn-progres-utrecht-whiteLine":false});
				});
			},500);

			this.showTransitorScore(false);

			this.setSlider();

		},

		data(){
			return {
				baseUrl : url
			}
		},
		methods:{
			...mapActions([
				'showNextButton',
				'setNextButtonAction',
				'toNextStage',
				"showTransitorScore"
			]),

			setSlider(){
				setTimeout(()=>{
					$('.slider').slick({
						dots: true,
						infinite: true,
						speed: 300,
						slidesToShow: 1,
						adaptiveHeight: false,
						arrows: false
					});
				}, 10);

			},
		},
		computed:{
			...mapGetters([
				'stageData',
			]),

			visualExists(){
				return this.stageData != null && this.stageData.visual != null;
			},

			visualIsJson(){
				if(this.stageData == null || this.stageData.visual == null) return false;
				let fileExtension = this.stageData.visual.substr(this.stageData.visual.lastIndexOf('.') + 1);
				return fileExtension.toLowerCase() == 'json';
			},

			backgroundImage: function() {

				console.log(this.stageData.background);

				if(typeof this.stageData.background === 'undefined'){ 
					return 'none'
				}

		        return 'url('+ this.baseUrl + this.stageData.background + ')';
		    },
		},

	}
</script>

<style scoped>
	.visual{width:80% !important;}
</style>


// WEBPACK FOOTER //
// src/components/minigames/Intro.vue